import { render, staticRenderFns } from "./TicketMetadataGroup.vue?vue&type=template&id=d83d292a&scoped=true&"
import script from "./TicketMetadataGroup.vue?vue&type=script&lang=ts&"
export * from "./TicketMetadataGroup.vue?vue&type=script&lang=ts&"
import style0 from "./TicketMetadataGroup.vue?vue&type=style&index=0&id=d83d292a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83d292a",
  null
  
)

export default component.exports